import React from 'react';
import type { Hero } from 'types/hero';
import { Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';

const HeroAbout: React.FC<Hero> = ({ subTitle, title }) => {
  return (
    <Wrap className="text-center" tagName="header">
      <div className="grid gap-y-3 max-w-4xl justify-self-center">
        <HeadingBody
          {...{
            level: '4',
            tagName: 'h2',
            title: subTitle,
          }}
        />
        <HeadingBody
          {...{
            level: '2',
            tagName: 'h1',
            title: title,
          }}
        />
      </div>
    </Wrap>
  );
};

export default HeroAbout;
